// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import VueSeamlessScroll from 'vue-seamless-scroll'


// axios.defaults.baseURL = 'http://api.iceo.com.cn/' 
axios.defaults.timeout = 5000 // 请求超时
Vue.prototype.$axios = axios

Vue.config.productionTip = true

Vue.use(ElementUI)

Vue.use(VueSeamlessScroll)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  // components: { App },
  // template: '<App/>'
  render: h=> h(App)
})



// WEBPACK FOOTER //
// ./src/main.js